import { isPlatformWeb, isPlatformAndroid, isPlatformIos, isPlatformTvos } from 'renative';
import { IOneTrustInstance } from './types';
import { OneTrustWeb, OneTrustMobile, OneTrustDisabled } from './services';

const getInstance = (): IOneTrustInstance | undefined => {
    if (isPlatformWeb) {
        return new OneTrustWeb();
    }
    if (isPlatformAndroid || isPlatformIos || isPlatformTvos) {
        return new OneTrustMobile();
    }

    return new OneTrustDisabled();
};

export const OneTrust = getInstance();
